import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import {
  formatDateString,
  getShipmentCreatedAt,
} from "../../utils/outbound-labels-utils";

const catalogEntry = fgColumnEntries["shipment-created-at"];

export const ShipmentCreatedAtColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => (
    <RedoTableTextCell
      text={formatDateString(getShipmentCreatedAt(row)?.toISOString() ?? "")}
    />
  ),
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
